<template>
	<get-started v-if="step === 0" key="get-started-step" :set-step="setStep" :affiliate-code="affiliateCode" />
	<skin-tone-level
		v-else-if="step === 1"
		key="skin-tone-level-step"
		:levels="levels"
		:is-active-level="isActiveLevel"
		:set-level-id="setLevelId"
		:set-level-name="setLevelName"
		:set-step="setStep"
	/>
	<skin-tone-picture
		v-else-if="step === 2"
		key="skin-tone-picture-step"
		:sublevel-images="sublevelImages"
		:is-active-sublevel="isActiveSublevel"
		:set-sublevel-name="setSublevelName"
		:set-sublevel-id="setSublevelId"
		:set-step="setStep"
	/>
	<coverage-type
		v-else-if="step === 3"
		key="coverage-type-step"
		:coverage-name="coverageName"
		:set-step="setStep"
		:set-coverage-name="setCoverageName"
		:set-coverage-id="setCoverageId"
	/>
	<powder-type
		v-else-if="step === 4"
		key="powder-type-step"
		:level-id="levelId"
		:powder-type-name="powderTypeName"
		:set-powder-type-name="setPowderTypeName"
		:set-powder-type-id="setPowderTypeId"
		:set-step="setStep"
	/>
	<age v-else-if="step === 5" key="age-step" :age-range="ageRange" :set-age-range="setAgeRange" :set-step="setStep" />
	<!--
	<contact-info
		v-else-if="step === 6"
		key="contact-info"
		:privacy-route="privacyRoute"
		:initial-full-name="fullName"
		:initial-email="email"
		:set-step="setStep"
		:set-full-name="setFullName"
		:set-email="setEmail"
		:set-send-email="setSendEmail"
	/>
	-->
	<preparing v-else-if="step === 6" key="preparing-step" :loading="loading" :step="step" :set-step="setStep" />
	<results
		v-else-if="step === 7"
		key="results-step"
		:privacy-route="privacyRoute"
		:initial-full-name="fullName"
		:initial-email="email"
		:results="results"
		:send-results="sendResults"
		:reset="reset"
		:affiliate="affiliate"
	/>
</template>
<script setup>
import { onMounted } from 'vue'
import { storeToRefs } from 'pinia'

import GetStarted from './GetStarted.vue'
import SkinToneLevel from './SkinToneLevel.vue'
import SkinTonePicture from './SkinTonePicture.vue'
import CoverageType from './CoverageType.vue'
import PowderType from './PowderType.vue'
import Age from './Age.vue'
import ContactInfo from './ContactInfo.vue'
import Preparing from './Preparing.vue'
import Results from './Results.vue'

import { useColorMatchStore } from '@stores'

const props = defineProps({
	affiliate: {
		type: Object,
		default: null,
	},
	affiliateCode: {
		type: String,
		default: null,
	},
	quizUuid: {
		type: String,
		required: true,
	},
	progressEndpoint: {
		type: String,
		required: true,
	},
	resultsEndpoint: {
		type: String,
		required: true,
	},
	privacyRoute: {
		type: String,
		required: true,
	},
})

const store = useColorMatchStore()
const {
	levels,
	isActiveLevel,
	step,
	sublevelImages,
	isActiveSublevel,
	coverageName,
	levelId,
	powderTypeName,
	ageRange,
	fullName,
	email,
	loading,
	results,
} = storeToRefs(store)
const {
	setUuid,
	setResultsEndpoint,
	setProgressEndpoint,
	setStep,
	setLevelId,
	setLevelName,
	setSublevelName,
	setSublevelId,
	setCoverageName,
	setCoverageId,
	setPowderTypeName,
	setPowderTypeId,
	setAgeRange,
	setFullName,
	setEmail,
	setSendEmail,
	sendResults,
	reset,
} = store

onMounted(async () => {
	setUuid(props.quizUuid)
	setResultsEndpoint(props.resultsEndpoint)
	setProgressEndpoint(props.progressEndpoint)

	const promises = Object.values(levels.value).map((level) => {
		return level.images.map((obj) => {
			return new Promise((resolve) => {
				const img = new Image()
				img.src = obj.src
				img.onload = resolve
			})
		})
	})
	await Promise.all(promises.flat())
})
</script>
